import usePrivateAxios from '@/common/api/usePrivateAxios'
import { INTEGRATION_PROVIDER } from '@/features/modelIntegrationCodes/constants/providers.constant'
import { IntegrationCodeMatch } from '@/features/modelIntegrationCodes/types/suggestedModel.type'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

export type ScoredIntegrationCodesMeta = {
  page: number
  max_pages: number
  per_page: number
  total: number
}

interface UseScoredIntegrationCodesProps {
  modelIntegrationCodeId?: string
  equipmentId?: string
  modelSearch?: string
  manufacturerSearch?: string
  page?: number
  perPage?: number
  enabled?: boolean
}

export const useScoredIntegrationCodes = ({
  modelIntegrationCodeId,
  equipmentId,
  modelSearch = '',
  manufacturerSearch = '',
  page,
  perPage,
  enabled = true,
}: UseScoredIntegrationCodesProps) => {
  const privateAxios = usePrivateAxios()

  const { data: { data = [], meta } = { data: [] as IntegrationCodeMatch[], meta: undefined }, ...rest } = useQuery({
    queryKey: [
      'modelIntegrationCodes',
      'scored',
      modelIntegrationCodeId,
      equipmentId,
      modelSearch,
      manufacturerSearch,
      page,
      perPage,
    ],
    enabled: enabled && !!modelIntegrationCodeId && !!equipmentId,
    queryFn: () =>
      privateAxios.get(`/equipment_models/${modelIntegrationCodeId}/scored_integration_codes`, {
        params: {
          provider: INTEGRATION_PROVIDER,
          equipment_id: equipmentId,
          model_search: modelSearch || undefined,
          manufacturer_search: manufacturerSearch || undefined,
          page,
          per_page: perPage,
        },
      }),
    select: (response: { data: { data: IntegrationCodeMatch[]; meta: ScoredIntegrationCodesMeta } }) => ({
      data: response?.data?.data ?? [],
      meta: response?.data?.meta,
    }),
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
